"use strict";
/**
 * IMAGES
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanUploadResponseCode = exports.SCAN_QUALITY_GROUPED_KEYS = void 0;
/**
 * SCAN QUALITY
 */
// Combined/grouped category keys for user display
exports.SCAN_QUALITY_GROUPED_KEYS = [
    'fullFaceScore',
    'rotationScore',
    'occlusionScore',
    'foreheadCoverage',
    'cheekCoverage', // Combined from left/right cheeks
    'eyeCoverage', // Combined from left/right eyes
    'resolutionScore',
    'focusScore',
    'lightnessScore',
    'lightDirectionScore',
    'colortoneScore',
    'shadowsScore',
];
/**
 * SCAN UPLOAD RESPONSE
 */
// Scan upload response codes
exports.ScanUploadResponseCode = {
    SUCCESS: 'SUCCESS',
    DAILY_LIMIT_REACHED: 'DAILY_LIMIT_REACHED',
};
//# sourceMappingURL=scan.js.map